module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tab', {
    attrs: {
      "active-color": "#fc2d65"
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": _vm.filterType == 'category'
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeTab('category')
      }
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": _vm.filterType == 'brand'
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeTab('brand')
      }
    }
  }, [_vm._v("品牌")])], 1), _vm._v(" "), _c('div', {
    staticClass: "commdity flex"
  }, [_c('div', {
    staticClass: "l vux-1px-r"
  }, [_c('scroller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterType == 'category'),
      expression: "filterType == 'category'"
    }],
    attrs: {
      "height": _vm.scrollH,
      "lock-x": ""
    }
  }, [_c('div', _vm._l((_vm.categoriesList), function(category, index) {
    return _c('div', {
      key: category._id,
      staticClass: "aside-item",
      class: {
        active: _vm.seletedCategoryId == category._id
      },
      on: {
        "click": function($event) {
          _vm.navTab(index, category._id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(category.name) + "\n                    ")])
  }))]), _vm._v(" "), _c('scroller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterType == 'brand'),
      expression: "filterType == 'brand'"
    }],
    attrs: {
      "height": _vm.scrollH,
      "lock-x": ""
    }
  }, [_c('div', _vm._l((_vm.brandsList), function(brand, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filterType == 'brand'),
        expression: "filterType == 'brand'"
      }],
      key: brand._id,
      staticClass: "aside-item",
      class: {
        active: _vm.seletedCategoryId == brand._id
      },
      on: {
        "click": function($event) {
          _vm.navTab(index, brand._id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(brand.name) + "\n                    ")])
  }))])], 1), _vm._v(" "), (_vm.productList.length == 0) ? _c('div', {
    staticClass: "nodata"
  }, [_c('img', {
    attrs: {
      "src": require("./nodata.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("这里还什么都没有")])]) : _vm._e(), _vm._v(" "), (_vm.scrollH) ? _c('scroller', {
    ref: "scrollerEvent",
    staticClass: "r flex-1",
    attrs: {
      "scroll-bottom-offst": 50,
      "height": _vm.scrollH,
      "lock-x": ""
    },
    on: {
      "on-scroll-bottom": _vm.onScrollBtm
    }
  }, [_c('div', {
    staticClass: "box2"
  }, [_vm._l((_vm.productList), function(product, index) {
    return _c('div', {
      key: product._id,
      staticClass: "commodity flex vux-1px-b",
      on: {
        "click": function($event) {
          _vm.toDetail(product._id)
        }
      }
    }, [_c('div', {
      staticClass: "img",
      class: 'img-' + index
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "alt": ""
      }
    })]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "pic"
      },
      on: {
        "after-enter": function($event) {
          _vm.listIndex = -1
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.listIndex),
        expression: "index==listIndex"
      }],
      staticClass: "img img2"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "commodity-r "
    }, [_c('span', {
      staticClass: "ellipsis-2"
    }, [_vm._v(_vm._s(product.title)), (product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(product.specLabel) + ")")]) : _vm._e(), (product.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('b', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(product.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addCart(product._id, product.category, 'img-' + index, _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120')
        }
      }
    }, [_c('i', {
      staticClass: "icon-jia iconfont text-center"
    })])], 1)
  }), _vm._v(" "), (_vm.productList.length > 0) ? _c('load-more', {
    attrs: {
      "tip": _vm.loadText,
      "background-color": "white",
      "show-loading": _vm.isMoreList
    }
  }) : _vm._e()], 2)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7684e20"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Classify/Classify.vue
// module id = 606
// module chunks = 0